$(function () {

  $("#searchsubmit, .search-icon-image").on("click", function(e) {

    var $nearestCollapsingInput = $(this).parents(".searchform").find(".collapsing-input");
    var $nearestSubmitButton = $(this).parents(".searchform").find("#searchsubmit");

    if ($nearestCollapsingInput.hasClass("s-open")) {
      return true;
    } else {
      e.preventDefault();

      $nearestCollapsingInput.addClass("s-open");
      $nearestCollapsingInput.focus();
      $nearestSubmitButton.val("");
      $nearestSubmitButton.toggleClass("go-button");

      return false;
    }
  });

  document.addEventListener('click', ({target}) => {
    if (!target.matches('.nav-hamburger')) return;

    target.classList.toggle('nav-hamburger--active');
    document.querySelector('.mobile-nav').classList.toggle('mobile-nav--active');
    document.querySelector('body').classList.toggle('no-scroll');
  })

  document.addEventListener('click', ({target}) => {
    if (!target.matches('.mobile-nav__menu-item--has-children')) return;

    target.classList.toggle('mobile-nav__menu-item--active');
  })
});
